<script>
import ListingModel from "@/views/Evaluation/File/Components/ListingModel.vue"

export default {
    components: {ListingModel}
}
</script>

<template>
    <ListingModel
        type="EVALUATION_PERFORMANCE"
        root-path="intranet_evaluation_file_performances"
        intranet
    />
</template>